import { getPropertyEnum, getPropertyString } from "./propertyUtilities";
import { ActionModel } from "../ActionModel";
import { DispositionCode } from "../enums/DispositionCode";
import { PropertyType } from "../enums/PropertyType";
import { Piping } from "../../piping";
import { InterviewState } from "../states/InterviewState";

export const getDispositionCode = (action: ActionModel) =>
    getPropertyEnum(action, DispositionCode, PropertyType.Status);

export const getExitUrl = (action: ActionModel, interview: InterviewState) => {
    const redirectUrl = getPropertyString(action, PropertyType.ExitUrl);
    return Piping.evaluateRecalls(interview, redirectUrl);
};
